import * as React from "react";
import { useLocation } from "wouter";
import { ArrowLeft, Truck } from "lucide-react";
import { MovesToMake } from "./MovesToMake.js";

/**
 * /organize/moves — every planned move in the household, grouped by
 * destination. Reached from the Organize hub's "Needs you now" row and from the
 * toast after "Move later" (docs/organize-declutter-onboarding-design.md §6b).
 */
export default function MovesPage() {
  const [, navigate] = useLocation();
  return (
    <div className="max-w-xl mx-auto space-y-6">
      <header>
        <button
          onClick={() => navigate("/organize")}
          className="inline-flex items-center gap-1 text-sm text-faint hover:text-primary transition-colors mb-2"
        >
          <ArrowLeft className="w-4 h-4" />Organize
        </button>
        <h1 className="text-4xl font-semibold text-ink font-headline tracking-[-0.02em] flex items-center gap-2">
          <Truck className="w-7 h-7 text-primary" />Moves to make
        </h1>
        <p className="text-body mt-1 text-sm">
          You've decided where these go. Take them there, then mark them moved.
        </p>
      </header>
      <MovesToMake emptyText="Nothing to move right now." />
    </div>
  );
}
